import { createCss } from './createCss';
import { presetCssPlugins } from './presets';
/** @deprecated */ export const deprecatedCss = createCss(presetCssPlugins);

//# sourceMappingURL=deprecatedCss.js.map